import { Checkbox, FormControlLabel, Stack } from '@mui/material'
import { Control, Controller } from 'react-hook-form'

interface CheckboxGroupFieldProps {
  name: string
  options: { label: string; value: string }[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<any>
}

const CheckboxGroupField = ({ name, options, control }: CheckboxGroupFieldProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const fieldValue = Array.isArray(field.value) ? (field.value as string[]) : []
        return (
          <Stack>
            {options.map((opt) => (
              <FormControlLabel
                key={opt.value}
                control={
                  <Checkbox
                    checked={fieldValue.includes(opt.value)}
                    onChange={(_e, checked) => {
                      const current = fieldValue
                      const newValue = checked
                        ? [...current, opt.value]
                        : current.filter((v: string) => v !== opt.value)
                      field.onChange(newValue)
                    }}
                  />
                }
                label={opt.label}
              />
            ))}
          </Stack>
        )
      }}
    />
  )
}

export default CheckboxGroupField
